module.exports = __webpack_public_path__ + "img/app-icon.73a06fb5.webp";